import { useState, useEffect, useContext } from "react";
import { motion } from "framer-motion";
import { ToastContainer, toast } from "react-toastify";
import Footer from "../../includes/footer-tab";
import Preloader from "../Preloader";
import BackButton from "../../includes/Back_btn";
import { AuthContext } from "../../context/AuthContext";
import { useNavigate, Link } from "react-router-dom";
import withdrawalImage from '../../assets/images/Withdrawal.jpeg';
import 'react-toastify/dist/ReactToastify.css';

function Withdrawal() {
  const navigate = useNavigate();
  const { isAuthenticated, profile, WithdrawMoney } = useContext(AuthContext);
  const [preloader, setpreloader] = useState(true);
  const [Balance, setBalance] = useState("Loading..");
  const [WinningBalance, setWinningBalance] = useState("0");
  const [Minimum, setMinimum] = useState(950);
  const [UPI, setUPI] = useState(false);
  const [IMPS, setIMPS] = useState(false);
  const [Password, setPassword] = useState("");
  const [StartTime, setStartTime] = useState("");
  const [EndTime, setEndTime] = useState("");
  const [currentTime, setCurrentTime] = useState("");
  const [Amount, setAmount] = useState(950);
  const [BankCard, setBankCard] = useState("");
  const [AccountHolder, setAccountHolder] = useState("");
  const [Account, setAccount] = useState("");
  const [Ifsc, setIfsc] = useState("");
  const [BankName, setBankName] = useState("");
  const [WithdrawalStatus, setWithdrawalStatus] = useState(false);

  if (!isAuthenticated) {
    navigate("/login");
  }

  const message = (status, text) => {
    const options = {
      position: "top-right",
      autoClose: 5000,
      theme: "colored",
    };
    if (status === 1) toast.success(text, options);
    else if (status === 0) toast.error(text, options);
    else if (status === 2) toast.warning(text, options);
  };

  const handleRecharge = () => {
    const numericBalance = Number(String(Balance).replace(/,/g, "")) || 0;
    const numericWinning = Number(String(WinningBalance).replace(/,/g, "")) || 0;
    const numericAmount = Number(Amount);
    const minRequired = Number(Minimum) || 950;

    if (Amount === "" || isNaN(numericAmount) || numericAmount <= 0) {
      message(0, "Please enter a valid Amount");
    } else if (numericAmount < minRequired) {
      message(0, `Minimum withdrawal amount is ₹${minRequired}`);
    } else if (numericAmount > numericBalance) {
      message(0, "Insufficient Wallet balance");
    } else if (numericAmount > numericWinning) {
      message(0, `You can only withdraw your winning amount. Available Winning: ₹${numericWinning}`);
    } else if (IMPS && (AccountHolder === "" || Account === "" || BankName === "" || Ifsc === "")) {
      message(0, "Please fill all Bank details");
    } else if (UPI && BankCard === "") {
      message(0, "Please select Payment Mode");
    } else if (UPI && Password === "" && BankCard !== "Bank") {
      message(0, "Please enter UPI Mobile Number");
    } else {
      setpreloader(true);
      WithdrawMoney(
        numericAmount,
        Password,
        IMPS ? "Bank" : BankCard,
        Account,
        Ifsc,
        AccountHolder,
        BankName,
        (data, success) => {
          setpreloader(false);
          if (!success || !data || data.status === 0 || data.error) {
            message(0, data?.msg || data?.message || "Withdrawal failed");
          } else if (data.status === 1 || data.status === true) {
            message(1, data?.msg || data?.message || "Withdrawal request sent successfully!");
            setTimeout(() => {
              navigate("/mine");
            }, 1000);
          } else {
            message(0, data?.msg || data?.message || "Something went wrong");
          }
        }
      );
    }
  };

  const inputAmount = (event) => {
    let amount = parseInt(event.target.value, 10);
    setAmount(isNaN(amount) ? "" : amount);
  };

  useEffect(() => {
    profile((data) => {
      setpreloader(false);
      if (data.error) {
        message(0, data.message);
      } else {
        setBalance(data.data[0].wallet);
        const minAmt = Number(data.data[0].setting?.withdrawal_amount) || 950;
        setMinimum(minAmt >= 950 ? minAmt : 950);
        if (data.data[0].winning_wallet !== undefined) {
          setWinningBalance(data.data[0].winning_wallet);
        }
        setStartTime(data.data[0].setting.startwith);
        setEndTime(data.data[0].setting.endwith);
        setIMPS(data.data[0].setting.isbank == 0 ? false : true);
        setUPI(data.data[0].setting.isUpi == 0 ? false : true);

        let dataa = data.data[0].lastWithdrawal;
        if (dataa != null) {
          setAccount(dataa.bank_ac_no);
          setAccountHolder(dataa.ac_holder_name);
          setIfsc(dataa.ifsc_code);
          setBankName(dataa.bank_name);
        }
      }
    });
  }, [profile]);

  useEffect(() => {
    const updateCurrentTime = () => {
      const now = new Date();
      const hours = String(now.getHours()).padStart(2, "0");
      const minutes = String(now.getMinutes()).padStart(2, "0");
      const seconds = String(now.getSeconds()).padStart(2, "0");
      setCurrentTime(`${hours}:${minutes}:${seconds}`);
    };
    const intervalId = setInterval(updateCurrentTime, 1000);
    updateCurrentTime();
    return () => clearInterval(intervalId);
  }, []);

  const isTimeBetween = () => {
    if (!currentTime || !StartTime || !EndTime) return false;
    const [currentHour, currentMinute, currentSecond] = currentTime.split(":").map(Number);
    const [startHour, startMinute, startSecond] = StartTime.split(":").map(Number);
    const [endHour, endMinute, endSecond] = EndTime.split(":").map(Number);

    const currentDate = new Date();
    const startDate = new Date(currentDate);
    startDate.setHours(startHour, startMinute, startSecond);

    const endDate = new Date(currentDate);
    endDate.setHours(endHour, endMinute, endSecond);

    const checkDate = new Date(currentDate);
    checkDate.setHours(currentHour, currentMinute, currentSecond);

    return checkDate >= startDate && checkDate <= endDate;
  };

  useEffect(() => {
    if (isTimeBetween()) {
      setWithdrawalStatus(true);
    } else {
      setWithdrawalStatus(false);
    }
  }, [currentTime, StartTime, EndTime]);

  return (
    <>
      <style>{`
        .recharge_box {
          border-radius: 15px;
          padding: 20px;
          font-family: 'Orbitron', sans-serif;
          box-shadow: 0 0 15px #00000066;
        }
        .bonus-tag {
          background: #ff4081;
          padding: 10px 20px;
          border-radius: 10px;
          display: inline-block;
          font-weight: bold;
          font-size: 1.1rem;
          margin-bottom: 15px;
          box-shadow: 0 0 10px #ff4081;
        }
        .game-withdrawal-options {
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          gap: 15px;
          margin: 20px 0;
        }
        .WithdrawalBox {
          flex: 1 1 30%;
          border: 2px solid #444;
          border-radius: 15px;
          padding: 15px;
          text-align: center;
          transition: all 0.3s ease;
          cursor: pointer;
          position: relative;
        }
        .WithdrawalBox img {
          max-width: 80px;
          margin-bottom: 10px;
        }
        .WithdrawalBox p {
          color: #fff;
          font-weight: 600;
          margin: 0;
        }
        .WithdrawalBox.selected {
          border-color: #00ff99;
          box-shadow: 0 0 15px #00ff9977;
          background: #0d83e2;
        }
        .custom-field.one input {
          background: transparent;
          color: black;
          border-bottom: 2px solid #00ffff;
          font-size: 1rem;
        }
        .custom-field.one .placeholder {
          color: #ccc;
        }
        .input_box_btn {
          margin-top: 25px;
        }
        .input_box_btn .login_btn {
          width: 100%;
          background: linear-gradient(to right, #00ff99, #33ccff);
          border: none;
          border-radius: 10px;
          color: #000;
          font-weight: bold;
          font-size: 1rem;
          box-shadow: 0 0 10px #00ffcc;
          transition: 0.3s ease;
        }
        .input_box_btn .login_btn:hover {
          background: linear-gradient(to right, #33ccff, #00ff99);
          box-shadow: 0 0 15px #00ffcc, 0 0 30px #00ffcc inset;
          color: #000;
        }
      `}</style>

      <Preloader status={preloader} />
      <ToastContainer />
      <motion.div
        initial={{ translateX: -100 }}
        animate={{ translateX: 0 }}
        exit={{ translateX: 0 }}
        transition={{ duration: 0.2 }}
      >
        <div className="login header">
          <div className="item">
            <BackButton />
            <p>Withdrawal</p>
            <Link to="/history/withdrawal" className="historyright"></Link>
          </div>
        </div>
        <div className="recharge recharge_box">
          <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "15px" }}>
            <div className="bonus-tag">Wallet: ₹ {Balance}</div>
            <div className="bonus-tag" style={{ background: "#2e7d32" }}>Winning: ₹ {WinningBalance}</div>
          </div>
          {WithdrawalStatus ? (
            <>
              {UPI && (
                <div className="game-withdrawal-options">
                  {["Paytm", "Phonepe", "GPay"].map((method) => (
                    <div
                      key={method}
                      className={`WithdrawalBox ${BankCard === method ? "selected" : ""}`}
                      onClick={() => setBankCard(method)}
                    >
                      <img src={method === "Paytm"
                        ? "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR363BO6LXUKGXXHiOTaHnqqDXgwpw4qOoA&s"
                        : method === "Phonepe"
                          ? "https://cdn.worldvectorlogo.com/logos/phonepe-1.svg"
                          : "https://cdn.worldvectorlogo.com/logos/google-pay-2.svg"
                      } alt={method} />
                      <p>{method}</p>
                    </div>
                  ))}
                </div>
              )}

              {IMPS && (
                <>
                  <label className="custom-field one">
                    <input type="text" onInput={(e) => setAccountHolder(e.target.value)} value={AccountHolder} placeholder="&nbsp;" />
                    <span className="placeholder">Enter Account Holder Name</span>
                  </label>
                  <label className="custom-field one">
                    <input type="text" onInput={(e) => setAccount(e.target.value)} value={Account} placeholder="&nbsp;" />
                    <span className="placeholder">Enter Account Number</span>
                  </label>
                  <label className="custom-field one">
                    <input type="text" onInput={(e) => setBankName(e.target.value)} value={BankName} placeholder="&nbsp;" />
                    <span className="placeholder">Enter Bank Name</span>
                  </label>
                  <label className="custom-field one">
                    <input type="text" onInput={(e) => setIfsc(e.target.value)} value={Ifsc} placeholder="&nbsp;" />
                    <span className="placeholder">Enter IFSC Code</span>
                  </label>
                </>
              )}

              {UPI && BankCard !== "Bank" && (
                <label className="custom-field one">
                  <input type="tel" onInput={(e) => setPassword(e.target.value)} value={Password} placeholder="&nbsp;" />
                  <span className="placeholder">Enter UPI Mobile Number</span>
                </label>
              )}

              <label className="custom-field one">
                <input type="tel" onInput={(e) => inputAmount(e)} value={Amount} placeholder="&nbsp;" />
                <span className="placeholder">Enter Amount (Min ₹{Minimum})</span>
              </label>
              <p>
                <b>Note:</b> Minimum Withdrawal amount is ₹{Minimum} (Sirf Winning Bet Amount withdraw hoga)
              </p>
              <div className="input_box_btn">
                <button className="login_btn ripple" onClick={handleRecharge}>
                  Withdrawal
                </button>
              </div>
            </>
          ) : (
            <p style={{ color: "red", fontWeight: "bold" }}>
              Withdrawal time closed. Please try again between {StartTime} and {EndTime}.
            </p>
          )}
          <img src={withdrawalImage} style={{ width: '100%', marginTop: '20px', borderRadius: '10px' }} />
        </div>
      </motion.div>
      <Footer page="recharge" />
    </>
  );
}

export default Withdrawal;
